export default __webpack_public_path__ + "img/venteny-logo.e7dcf167.svg";